import script from "./RoomScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomScreen.vue?vue&type=script&setup=true&lang=js"

import "./RoomScreen.vue?vue&type=style&index=0&id=5ec21c1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec21c1c"]])

export default __exports__